import Alert from "../models/Alert";

export default {
    namespaced: true,
    state: {
        globalLoadingState: true,
        loadingState: false,
        alerts: [],
        globalInitData: {},
        authenticatedInitData: {},
        /** Index data **/
        titlePage: '',
        selectedItems: [],
        itemsCount: 0,
        numberActivePage: 1,
        numberOfPage: 1,
        searchValue: '',
        timer: null,
    },
    getters: {
        getGlobalLoadingState(state) {
            return state.globalLoadingState;
        },
        getLoadingState(state) {
            return state.loadingState;
        },
        getAlerts(state) {
            return state.alerts;
        },
        getGlobalInitData(state) {
            return state.globalInitData;
        },
        getAuthenticatedInitData(state) {
            return state.authenticatedInitData;
        },
        getTitlePage(state) {
            return state.titlePage;
        },
        getSelectedItems(state) {
            return state.selectedItems;
        },
        getItemsCount(state) {
            return state.itemsCount;
        },
        getNumberActivePage(state) {
            return state.numberActivePage;
        },
        getNumberOfPage(state) {
            return state.numberOfPage;
        },
        getSearchValue(state) {
            return state.searchValue;
        },
    },
    mutations: {
        setGlobalLoadingState(state, value) {
            state.globalLoadingState = value;
        },
        setLoadingState(state, value) {
            state.loadingState = value;
        },
        addAlert(state, {content, type}) {
            let alert = new Alert(content, type);
            state.alerts.push(alert);

            setTimeout(() => {
                let index = state.alerts.indexOf(alert);
                state.alerts.splice(index, 1);
            }, 6000);
        },
        setGlobalInitData(state, value) {
            state.globalInitData = value;
        },
        setAuthenticatedInitData(state, value) {
            state.authenticatedInitData = value;
        },
        setTitlePage(state, value) {
            state.titlePage = value;
        },
        addSelectedItem(state, item) {
            state.selectedItems.push(item);
        },
        removeSelectedItem(state, item) {
            let idx = state.selectedItems.indexOf(item);
            state.selectedItems.splice(idx, 1);
        },
        clearSelectedItems(state) {
            state.selectedItems = [];
        },
        setItemsCount(state, value) {
            state.itemsCount = value;
        },
        setNumberActivePage(state, value) {
            state.numberActivePage = value;
        },
        setNumberOfPage(state, value) {
            state.numberOfPage = value;
        },
        setSearchValue(state, value) {
            state.searchValue = value;
        }
    },
    actions: {},
}
